const syncProviderTypes = {
    0: 'Salesforce',
    1: 'Pq',
    2: 'Riskpulse'
}

export default syncProviderTypes;